import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Alert } from '@app/models';

import { AuthenticationService } from '@app/services';

import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AdminAuthGuard implements CanActivate {
  toast = new Alert();

  access: boolean;
  
  constructor(
    public translate: TranslateService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  // Permission d'acces vers la route
  canActivate(
    route: ActivatedRouteSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
      const redirectUserHome = route.data.redirectUserHome || false;
      return this.checkLogin(redirectUserHome); 
  } 

  // Vérification du statut d'authentification
  checkLogin(redirectUserHome: any): any {

    if(this.authenticationService.hasNoRole()){
      // sinon retour au login
      return this.redirect('/auth/login', !redirectUserHome);
    }

    // si role ne correspond pas a Admin
    if(!this.authenticationService.isAdmin()) {

      // si role Prospector retour a la prospection
      if(this.authenticationService.isProspector()) {
        return this.redirect('/admin/table-prospection', !redirectUserHome);
      }

      // si role Dealer retour au dashboard
      if(this.authenticationService.isDealer()) {
        return this.redirect('/dashboard', !redirectUserHome);
      }
  
      // si role User retour aux sites
      if(this.authenticationService.isUser()) {
        return this.redirect('/domains/mysites', !redirectUserHome);
      }

      // hardening : sinon retour au login
      return this.redirect('/auth/login');
    }

    return true;
  }

  // Redirection vers page indiquée
  redirect(page: string, alert = false){
    //accès refusé
    if(alert){
      Swal.fire({...this.toast, imageUrl: 'assets/images/lock-access.jpg', imageWidth: 100, title: this.translate.instant('Forbidden'), html: this.translate.instant('you don\'t have permission to access this page.')});
    }

    this.router.navigateByUrl(page);
    return false;
  }
}